import httpClient from "@/config/axios";
import type * as type from "@vTypes";

export async function getConfigIdForVersion(
  { configVersion }: { configVersion: number },
  { isAdmin }: { isAdmin: boolean },
  { selectedGroupId }: { selectedGroupId: string }
) {
  try {
    // 버전 누락 체크
    if (!configVersion) {
      throw new Error("configVersion is required");
    }

    // httpClient는 이미 baseURL이 설정되어 있으므로 상대 경로 사용
    // params 옵션으로 쿼리 파라미터 전달 (axios가 자동으로 처리)
    const response = await httpClient.get<type.ConfigObject>(
      `/roster/config/version/${configVersion}`,
      {
        params: {
          group_id: isAdmin ? selectedGroupId : null,
        },
      }
    );
    return response.config_id;
  } catch (error) {
    console.error("설정 ID 조회 실패:", error);
    throw error;
  }
}
